import { DocumentsPlus } from "@app/app-modules/documents-plus/documents-plus.model";
import { AbstractAdapter } from "@app/shared/models/adapter.model";

export enum viewStates {
  viewFileRoom,
  viewFileCabinets,
  viewFolders,
  viewSubFolders,
  viewFiles
}

export enum DocumentsPlusTypes {
  folder = "0",
  file = "1",
  create = "2"
}

export interface DocumentsPlusParms {
  state: viewStates;
  data: DocumentsPlus;
  application: string;
}

export class DocumentsPlusFileRoomAdapter extends AbstractAdapter<DocumentsPlus[]> {
  adapt(rawData: DocumentsPlus[]) {
    return [
      {
        id: Math.random(),
        description: "Company 1",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Company 2",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Company 3",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "File 1",
        type: DocumentsPlusTypes.file
      }
    ];

    return rawData;
  }
}

export class DocumentsPlusFileCabinetAdapter extends AbstractAdapter<DocumentsPlus[]> {
  adapt(rawData: DocumentsPlus[]) {
    return [
      {
        id: Math.random(),
        description: "File Cabinet 1",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "File Cabinet 2",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "File Cabinet 3",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "File 1",
        type: DocumentsPlusTypes.file
      },
      {
        id: Math.random(),
        description: "File 2",
        type: DocumentsPlusTypes.file
      },
      {
        id: Math.random(),
        description: "File 3",
        type: DocumentsPlusTypes.file
      },
      {
        id: Math.random(),
        description: "File 4",
        type: DocumentsPlusTypes.file
      }
    ];

    return rawData;
  }
}
export class DocumentsPlusFoldersAdapter extends AbstractAdapter<DocumentsPlus[]> {
  adapt(rawData: DocumentsPlus[]) {
    return [
      {
        id: Math.random(),
        description: "Agents",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Members",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Policies",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "random file 123",
        type: DocumentsPlusTypes.file
      }
    ];

    return rawData;
  }
}

export class DocumentsPlusSubFoldersAdapter extends AbstractAdapter<DocumentsPlus[]> {
  adapt(rawData: DocumentsPlus[]) {
    return [
      {
        id: Math.random(),
        description: "Eugene Borts",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Pedro Rivera",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Alex Chapman",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Miguel Hernandez",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Gina Verdon",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "Miguel Ochoa",
        type: DocumentsPlusTypes.folder
      },
      {
        id: Math.random(),
        description: "File 123",
        type: DocumentsPlusTypes.file
      }
    ];

    return rawData;
  }
}
export class DocumentsPlusFilesAdapter extends AbstractAdapter<DocumentsPlus[]> {
  adapt(rawData: DocumentsPlus[]) {
    return [
      {
        id: Math.random(),
        description: "Policy 123",
        type: DocumentsPlusTypes.file
      },
      {
        id: Math.random(),
        description: "Payroll",
        type: DocumentsPlusTypes.file
      },
      {
        id: Math.random(),
        description: "Misc Document",
        type: DocumentsPlusTypes.file
      },
      {
        id: Math.random(),
        description: "Paycheck",
        type: DocumentsPlusTypes.file
      },
      {
        id: Math.random(),
        description: "Insurance Info",
        type: DocumentsPlusTypes.file
      }
    ];

    return rawData;
  }
}
